import { useEffect, useState } from "react";

import Drawer from "../../../../common/drawer/Drawer";
import FormSection from "../shared/FormSection";
import Button from "../shared/Button";

const TYPES=[

    {

        value:"call",

        label:"Phone Call"

    },

    {

        value:"meeting",

        label:"Meeting"

    },

    {

        value:"whatsapp",

        label:"WhatsApp"

    },

    {

        value:"email",

        label:"Email"

    },

    {

        value:"document",

        label:"Document Collection"

    },

    {

        value:"general",

        label:"General"

    }

];

export default function FollowupDrawer({

    open,

    followup,

    onSave,

    onClose

}){

    const [

        form,

        setForm

    ]=useState({

        type:"call",

        followup_at:"",

        priority:"medium",

        reminder:"30",

        remark:""

    });

    useEffect(()=>{

        if(followup){

            setForm({

                type:followup.type || "call",

                followup_at:followup.followup_at || "",

                priority:followup.priority || "medium",

                reminder:followup.reminder || "30",

                remark:followup.remark || ""

            });

        }

        else{

            setForm({

                type:"call",

                followup_at:"",

                priority:"medium",

                reminder:"30",

                remark:""

            });

        }

    },[

        followup,

        open

    ]);

    function update(

        key,

        value

    ){

        setForm(previous=>({

            ...previous,

            [key]:value

        }));

    }

    async function handleSave(){

        await onSave?.(

            form

        );

    }

    return(

        <Drawer

            open={open}

            width={520}

            title={

                followup

                ?

                "Edit Follow-up"

                :

                "Schedule Follow-up"

            }

            onClose={onClose}

        >

            <FormSection

                title="Follow-up Details"

            >

                <div className="crm-form-grid">

                    <div className="form-group">

                        <label>

                            Type

                        </label>

                        <select

                            value={form.type}

                            onChange={e=>

                                update(

                                    "type",

                                    e.target.value

                                )

                            }

                        >

                            {

                                TYPES.map(type=>

                                    <option

                                        key={type.value}

                                        value={type.value}

                                    >

                                        {type.label}

                                    </option>

                                )

                            }

                        </select>

                    </div>

                    <div className="form-group">

                        <label>

                            Priority

                        </label>

                        <select

                            value={form.priority}

                            onChange={e=>

                                update(

                                    "priority",

                                    e.target.value

                                )

                            }

                        >

                            <option value="low">

                                Low

                            </option>

                            <option value="medium">

                                Medium

                            </option>

                            <option value="high">

                                High

                            </option>

                        </select>

                    </div>

                    <div className="form-group">

                        <label>

                            Follow-up Date & Time

                        </label>

                        <input

                            type="datetime-local"

                            value={form.followup_at}

                            onChange={e=>

                                update(

                                    "followup_at",

                                    e.target.value

                                )

                            }

                        />

                    </div>

                    <div className="form-group">

                        <label>

                            Reminder

                        </label>

                        <select

                            value={form.reminder}

                            onChange={e=>

                                update(

                                    "reminder",

                                    e.target.value

                                )

                            }

                        >

                            <option value="0">

                                No Reminder

                            </option>

                            <option value="15">

                                15 Minutes Before

                            </option>

                            <option value="30">

                                30 Minutes Before

                            </option>

                            <option value="60">

                                1 Hour Before

                            </option>

                            <option value="1440">

                                1 Day Before

                            </option>

                        </select>

                    </div>

                </div>

            </FormSection>

            <FormSection

                title="Remark"

            >

                <div className="form-group">

                    <label>

                        Notes

                    </label>

                    <textarea

                        rows={5}

                        value={form.remark}

                        onChange={e=>

                            update(

                                "remark",

                                e.target.value

                            )

                        }

                    />

                </div>

            </FormSection>

            <div className="drawer-footer">

                <Button

                    variant="secondary"

                    onClick={onClose}

                >

                    Cancel

                </Button>

                <Button

                    onClick={handleSave}

                >

                    {

                        followup

                        ?

                        "Save Changes"

                        :

                        "Schedule Follow-up"

                    }

                </Button>

            </div>

        </Drawer>

    );

}